import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import vistasuperplasths500Img from '@/assets/images/products/vistasuperplasths500.png';

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaSuperplastHs500 = () => {
  return (
    <div className=" 2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista Superplast HS 500"
        subTitle="(High Range Water Reducing Retarding Admixture)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct
          title="Description"
          imageUrl={vistasuperplasths500Img}
          content="Vista Super Plast HS 500 is a high range water reducing admixture formulated specifically to extend the working time of flowing concrete at high temperatures. Vista Super Plast HS 500 does not contain calcium chloride or any other ingredients that would promote corrosion."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Improved Dispersion Properties.",
                "Very High Water Reduction.",
                "Improved Strength And Density.",
                "Improved Compactness.",
                "Improved Cohesiveness.",
              ],
              [
                "Improves Rheology.",
                "Improved Flowability.",
                "Arrest Shrinkage.",
                "Improved Workability Retention.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Uses">
          <Paragraph content="Vista Super Plast HS 500 is recommended for use in free flowing concrete in piling, floors, slabs, foundations, slender components with packed reinforcement, walls and columns, and other structural elements." />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Aspect", "Light Brown Liquid"],
                ["Specific Gravity", "1.08 ± 0.02 @27°C"],
                ["Chloride Content", "0.2 % (MAX)"],
                ["pH", "> 6"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Precaution">
          <Paragraph content="Health & Safety Instruction: Vista Superplast HS 500 is non-toxic. Any splashes on the skin should be washed immediately with water." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaSuperplastHs500;
